import React from 'react';

export default class Show extends React.Component {
  constructor(props) {
    super();

    this.state = {
      show: !!props.condition,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({show: !!props.condition});
  }

  render() {
    return (
      <div {...this.props} style={{display: (this.state.show ? 'block' : 'none')}}>
        { this.props.children }
      </div>
    );
  }
}
